import { render, staticRenderFns } from "./ScrollCarousel.vue?vue&type=template&id=032ebdfa&scoped=true&"
import script from "./ScrollCarousel.vue?vue&type=script&lang=js&"
export * from "./ScrollCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ScrollCarousel.vue?vue&type=style&index=0&id=032ebdfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032ebdfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
